import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browsernotification',
  templateUrl: './browsernotification.component.html',
  styleUrls: ['./browsernotification.component.css']
})
export class BrowsernotificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
